<template>
  <div style="max-width:900px; margin: auto;">
      <br />
      <h2>{{$t('Customize')}}</h2>
   <hr />

<div class="seasoncast-card">
<h4>{{$t('ChannelInformation')}}</h4><hr >
<b>Name:</b> {{ channel.name }} <br />
<b>Username:</b> @{{ channel.id}}<br />
<b>Link:</b> <a v-bind:href="'https://seasoncast.com/'+channel.id">seasoncast.com/{{ channel.id}}</a><br />
<b>{{ $t('privacy-level') }}</b> {{ channel.community_password ? "Private": "Public"}}<br />
<b>Type:</b> {{ channel.premium.active ? "Premium" : "Free"}}
</div> 
<br />
<div class="seasoncast-card">
<h4>{{$t('ChannelDesign')}} <span style="font-size:0.5em;vertical-align:middle;" class="badge badge-dark">{{ $t('premium-only') }}</span></h4>
<hr />
{{$t('ChannelName')}}:
    <input type="text" v-model="channel.name" class="form-control" placeholder="Enter a channel name"> <br />

    {{$t('ChannelMainColor')}}:  <div class="scoreColor" @click="showNavColorPicker = !showNavColorPicker" v-bind:style="'cursor:pointer; width:100px; min-height:20px; color:white; margin-bottom:5px; border: 1px solid black; background-color: #'+channel.pageData.navcolor"  > #{{ channel.pageData.navcolor}}</div>

<chrome-picker v-if="showNavColorPicker"   v-model="channel.pageData.navcolor" @input="channel.pageData.navcolor.hex ? channel.pageData.navcolor = channel.pageData.navcolor.hex.split('#')[1] : false" /> 
<br />


<button class="btn btn-dark" @click="updateDesign">{{ $t('update-design') }}</button>


</div>
<br />
<div class="seasoncast-card">
    <h4>{{ $t('team-site') }}</h4><small>{{ $t('team-site-lets-you-create-an-independent-website-for-your-teams-live-streams-the-default-domain-for-your-team-site-is-username-mylivegame-com') }}</small><hr >
    <b>Link:</b> <a v-bind:href="'https://'+channel.id+'.mylivegame.com'">{{ channel.id}}.mylivegame.com</a>
    <br />
     <br />
    
</div>
<br />

<div class="seasoncast-card">
    <h4>{{$t('CommunityPassword')}} <span style="font-size:0.5em;vertical-align:middle;" class="badge badge-dark">{{ $t('premium-only') }}</span></h4>
    <small> {{ $t('make-your-channel-private-with-a-community-password-share-the-password-with-fans-you-would-like-to-have-viewing-access-to-the-channel') }}
</small>
    <hr />
    <b>{{ $t('privacy-level') }}</b> {{ channel.community_password ? "Private": "Public"}}<br /><br />
    <div class="form-check">
  
  <input class="form-check-input" type="radio" name="flexRadioDefault" value="false" v-model="channel.isVODLockOnly" @change="updateVODLock">
  <label class="form-check-label" for="flexRadioDefault1">
    {{ $t('live-feed-and-past-recordings-are-locked-by-community-password') }} <small v-if="!channel.community_password" >(Only applies if community password is set)</small>
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio" name="flexRadioDefault" value="true" v-model="channel.isVODLockOnly"  @change="updateVODLock" >
  <label class="form-check-label" for="flexRadioDefault2">
     {{ $t('live-feed-set-to-anyone-can-watch-past-recordings-are-locked-by-community-password') }} <small v-if="!channel.community_password">(Only applies if community password is set)</small>
  </label>
</div><br />

        <input type="text" v-model="channel.new_community_password" class="form-control" placeholder="Enter new community password"> <br />
<button class="btn btn-dark"  @click="updateCommunityPassword">{{ $t('set-new-password') }}</button> <button class="btn btn-danger" v-if="channel.community_password" @click="channel.new_community_password = ''; updateCommunityPassword()">Make Channel Public</button>


</div>
<br />
</div>
</template>
<script>
let API = "https://app.seasoncast.com/"
  import Swal from "sweetalert2"
  import axios from "axios"
import { Chrome } from 'vue-color'
export default {
  name: 'Customize',
  props: ['channel'],
  data: function () {
    return {
        showNavColorPicker: false,
        customDomain: undefined,
    }
  },
  components: {
     'chrome-picker':Chrome,
  },
     created: async function () {
    console.log("create call")

      this.getCustomDomain()
   },
   beforeUpdate: async function () {
   },
  methods: {
      updateDesign: async function (){
     
    this.showNavColorPicker = false
    // the endpoint to update is /v2/broadcaster/updatePageData and send pageData object with the following properties: channel.name, channel.pageData 

    let result = await axios.post(API+"v2/broadcaster/updatePageData", {
      ...this.$store.state.broadcasterAuth,
      pageData: {
        ...this.channel.pageData,
        name: this.channel.name,
      }
    })
    if (result.data.success){
      await Swal.fire({
        title: "Success!",
        text: "Design updated",
        type: "success",
      })
    }else{
        Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Error: '+JSON.stringify(result.data.reason),
  footer: 'Try action later or refresh page'
})
    }

      },
      updateVODLock: async function(){
        console.log(this.channel.isVODLockOnly)
    let getResponse = await axios.post(API+ "v2/broadcaster/updateVODLock", {
      ...this.$store.state.broadcasterAuth,
    VODLockStatus: (this.channel.isVODLockOnly == 'true') ? 1 : 0,
    
  }) 
  console.log(getResponse)
      },
          updateCommunityPassword: async function (){
         
    this.showNavColorPicker = false
      // the endpoint to update is /v2/broadcaster/updateCommunityPassword
    let result = await axios.post(API+ "v2/broadcaster/updateCommunityPassword", {
      ...this.$store.state.broadcasterAuth,
      community_password: this.channel.new_community_password
    })
    console.log(result)
    if (result.data.success){
      this.channel.community_password = this.channel.new_community_password
      this.channel.new_community_password = undefined
      Swal.fire({
  icon: 'success',
  title: 'Success',
  text: 'Community Password Updated'
})
    }
    else{
      Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Error: '+JSON.stringify(result.data.reason),
  footer: 'Try action later or refresh page'
})
    }

      },
      // get custom domain info : /v2/broadcaster/customDomain/get 
      // update custom domain info : /v2/broadcaster/customDomain/set
      updateCustomDomain: async function (){
        this.showNavColorPicker = false
        let result = await axios.post(API+ "v2/broadcaster/customDomain/set", {
          ...this.$store.state.broadcasterAuth,
          customDomain: this.channel.customDomainNew
        })
        if (result.data.success){
          Swal.fire({
  icon: 'success',
  title: 'Success',
  text: 'Custom Domain Updated'
})
this.customDomain = this.channel.customDomainNew
        }
        else{
          Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Error: '+JSON.stringify(result.data.reason),
  footer: 'Try action later or refresh page'
})
        }
      },
      getCustomDomain: async function (){
        let result = await axios.post(API+ "v2/broadcaster/customDomain/get", {
          ...this.$store.state.broadcasterAuth,
        })
        console.log(result)
        if (result.data.success){
          this.customDomain = result.data.result.domain
        }
      },
  }
}
</script>
